"use strict";

exports.__esModule = true;
exports.default = void 0;

// This file is automatically generated by scripts/build-corejs3-shipped-proposals.js
var _default = new Set(["esnext.array.find-last", "esnext.array.find-last-index", "esnext.typed-array.find-last", "esnext.typed-array.find-last-index"]);

exports.default = _default;